import { getAndReportPersistedExperimentTreatment } from '@ms/yammer-data/dist/domains/experiments/selectors';
import { reportError } from '@ms/yammer-data/dist/telemetry';
import { AuthenticatorType } from '@ms/yammer-web-authenticators';
import { isNAAChannelRecommendedWithTelemetry } from '@ms/yammer-web-support/dist/metaOsHub';

import { persistConfig } from '../../persistedState';

type IsNAASupportAvailable = () => Promise<boolean>;
export const isNAASupportAvailable: IsNAASupportAvailable = async () => {
  try {
    const [isNestedAppAuthSupportFeatureEnabled, isNAAChannelRecommended] = await Promise.all([
      getAndReportPersistedExperimentTreatment(persistConfig.key, 'TeamsMetaOSNestedAuthAppSupport'),
      isNAAChannelRecommendedWithTelemetry(),
    ]);

    return !!isNestedAppAuthSupportFeatureEnabled && isNAAChannelRecommended;
  } catch (error) {
    reportError({
      error,
      eventProperties: {
        errorCode: 'AuthBootstrapFailed',
        authenticatorType: AuthenticatorType.NestedAppAuth,
      },
    });

    return false;
  }
};
